import React, { useState } from "react";
import { UserOutlined, TeamOutlined, UsergroupAddOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import ChoiceOverview, { GameSuggestion } from "./ChoiceOverview";
import { soloGames } from "./saufhelper/drinkhelperOne";
import { twoPlayerGames } from "./saufhelper/drinkhelperTwo";
import { partyGames } from "./saufhelper/drinkhelperMore";

const Drinkhelper: React.FC = () => {
    const { t } = useTranslation();
    const players = [
        { to: "/saufAlone", icon: <UserOutlined />, labelKey: "pages.drinkhelper.players.single", hintKey: "pages.drinkhelper.hints.single", games: soloGames },
        { to: "/saufTwo", icon: <TeamOutlined />, labelKey: "pages.drinkhelper.players.double", hintKey: "pages.drinkhelper.hints.double", games: twoPlayerGames },
        { to: "/saufwithyourfriends", icon: <UsergroupAddOutlined />, labelKey: "pages.drinkhelper.players.party", hintKey: "pages.drinkhelper.hints.party", games: partyGames },
    ];
    const [selectedTo, setSelectedTo] = useState(players[2].to);
    const selected = players.find((player) => player.to === selectedTo) || players[2];
    const suggestions: GameSuggestion[] = selected.games.map((game) => ({ ...game }));

    return (
        <ChoiceOverview
            title={t("pages.drinkhelper.title")}
            subtitle={t("pages.drinkhelper.subtitle")}
            question={t("pages.drinkhelper.question")}
            items={players.map((player) => ({ to: player.to, icon: player.icon, title: t(player.labelKey), description: t(player.hintKey) }))}
            variant="drinkhelper"
            selectedTo={selectedTo}
            onSelect={setSelectedTo}
            suggestions={suggestions}
            suggestionTitle={t("pages.drinkhelper.suggestions")}
            playerCount={t(selected.labelKey)}
        />
    );
};

export default Drinkhelper;
